// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX


import { ioDatatypes } from "../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter } from "../blib.js";

import * as blib from "../../../blib/index.js";
import * as xlib from "../../../xlib/index.js";


import { IndexRoute, Router, Route, Link } from "react-router";

///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)





//import blib.Cookie = refs.blib.Cookie;

//import xlib = refs.xlib;
// var _ = xlib.lodash;
// var __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//var jsHelper = xlib.jsHelper;

//import blib = refs.blib;


//import blib.React = blib.React;
//import blib.ReactDOM = blib.ReactDOM;
//import blib.Redux = blib.Redux;
//import blib.ReactRedux = blib.ReactRedux;
//import blib.ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
//import blib.History = blib.History;
//import blib.ReactBootstrap = blib.ReactBootstrap;
//var blib.ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import refs.ioDatatypes1 = refs.ioDatatypes;



blib.injectTapEventPlugin();

import * as commonComponents from "./account/commoncomponents.js";
import * as accountDetails from "./account/accountdetails.js";
import * as resetPassword from "./account/resetpassword.js";
import * as signup from "./account/signup.js";
import * as login from "./account/login.js";


import * as statements from "./account/statements.js";


import * as config from "./client-config.js";











//import Alert = ReactBootstrap.Alert;


module components {


	export class Header extends blib.React.Component<{}, {}>{

		render() {
			return (
				<section>
					<nav className="navbar navbar-dark bg-primary">
						<div className="container">
							<div className="nav navbar-nav">
								<div className="nav-item" style={ { maxHeight: "40px", } }><a target="_blank" href={ config.pjscGlobalConfig.sharedConfig.domains.www.origin }><img style={ { maxWidth: "150px", marginTop: "-15px", } } src="img/logo-600.png" /></a></div>
								<div className="pull-xs-right">
									<a className="nav-link nav-item" target="_blank" href={ config.pjscGlobalConfig.sharedConfig.domains.www.origin }><strong>Website</strong></a>
									<a className="nav-link nav-item active" href={ config.pjscGlobalConfig.sharedConfig.domains.dashboard.origin }><strong>Dashboard</strong></a>
									<a className="nav-link nav-item" target="_blank" href={ config.pjscGlobalConfig.sharedConfig.domains.api.origin + "/docs/" }><strong>API Docs</strong></a>
									<login.components.LoginOrLogoutButton />
									<login.components.SignupOrEmptyButton />
								</div>
							</div>
						</div>
					</nav>
					<br />
				</section>
			)
		}
	}




	export class Splash extends blib.React.Component<{}, {}>{
		render() {
			//			<login.components.LoginStatusMonitor logedInRedirect={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.accountDetails} logedOutRedirect={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.login}/>
			return (
				<div>
					<login.components.LoginStatusMonitor logedInRedirect={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.accountDetails } logedOutRedirect={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.login } />
					<div className="card">
						<div className="card-block">
							<h1>You are not logged in.</h1>
							<p>Please <blib.ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.login }><strong>Login</strong></blib.ReactRouter.Link> or <blib.ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signup }><strong>Signup</strong></blib.ReactRouter.Link> to continue.
							</p>
						</div>
					</div>
				</div>
			);
		}
	}




	export class Message extends blib.React.Component<blib.ReactRouter.RouteComponentProps<{}, { id: number }>, {}>{
		render() {
			return <h3>message = { this.props.routeParams.id }</h3>;
		}
	}


	export class RootTemplate extends blib.React.Component<blib.ReactRouter.RouteComponentProps<any, any>, {}>{
		public render() {

			//log.info("AccountSpaApp", this);
			//var propsStr = xlib.serialization.JSONX.inspectStringify(this.props);
			// <login.components.LoginStatusMonitor logedOutRedirect={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.root} />

			//<h1>Dashboard.PhantomJsCloud.com</h1>




			//{/* change the <a>'s to <Link>'s */ }
			//<ul>
			//	<li><ReactRouter.Link to={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.root}>Splash</ReactRouter.Link></li>
			//	<li><ReactRouter.Link to={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.accountDetails}>AccountDetails</ReactRouter.Link></li>
			//	<li><ReactRouter.Link to={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.login}>Login</ReactRouter.Link></li>
			//	<li><ReactRouter.Link to={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.signup}>Signup</ReactRouter.Link></li>
			//	<li><ReactRouter.Link to={config.pjscGlobalConfigClient.sharedConfig.routes.spaRoutePaths.resetPasswordStart}>Reset Password</ReactRouter.Link></li>
			//</ul>
			return (
				<div>
					<Header />

					<div className="container">
						{/* next we replace `<Child>` with `this.props.children`
		  the router will figure out the children for us */
							this.props.children
						}


					</div>
				</div>
			);
		}
	}
}

/**
 * workflow for redux devtools v3  https://github.com/gaearon/redux-devtools
 */
module reduxDevTools {

	///////////////////////////////  REDUX DEVTOOLS v3
	const createDevTools = blib.ReduxDevTools.createDevTools;

	// Monitors are separate packages, and you can make a custom one
	const LogMonitor = blib.LogMonitor;
	const DockMonitor = blib.DockMonitor;
	// createDevTools takes a monitor and produces a DevTools component
	export const DevTools = createDevTools(
		// Monitors are individually adjustable with props.
		// Consult their repositories to learn about those props.
		// Here, we put LogMonitor inside a DockMonitor.
		<DockMonitor toggleVisibilityKey='ctrl-h'
			changePositionKey='ctrl-q'
			defaultPosition="bottom"
		>
			<LogMonitor theme='tomorrow' />
		</DockMonitor>
	);


}





module render {

	/**
 *  //create a single reducer function from our components
 */

	let reducerMappings = {
		//accountDetails: accountDetails.reduxState.reducer, //our example 'count' reducer
		//modalPopup:modalPopup.reducer, //bad pattern, instead each componenet should embed it's own ModalPopup if required, not sharing a global one.
		authentication: login.reduxScafolding.reducer,
		routing: blib.ReduxSimpleRouter.routeReducer, //include our routing module
	}

	reducerMappings[ accountDetails.reduxScafolding.reduxStateKey ] = accountDetails.reduxScafolding.reducer;  //trying to use this to help decouple the redux state from the root of the app
	reducerMappings[ statements.reduxScafolding.reduxStateKey ] = statements.reduxScafolding.reducer;


	const reducer = blib.Redux.combineReducers( reducerMappings );

	/**
	 * //binds "apply middleware" (the devTools) to our store if in #TRACE mode
	 */
	const finalCreateStore = __.isTrace ? blib.Redux.compose( reduxDevTools.DevTools.instrument() )( blib.Redux.createStore ) : blib.Redux.createStore;

	/**
	 * the whole state tree of the app  use actions to manipulate 
	 */
	const reduxStore: blib.Redux.Store = finalCreateStore( reducer );
	// session pass: a 401 whose reply cleared `isLogedIn` (the server refused the token) returns the page to sign-in; handler-made 401s
	// on authenticated routes keep the marker and do nothing here; the call's own error handling still runs (the rejection passes on)
	xlib.net.axios.interceptors.response.use( ( res ) => res, ( err ) => {
		if ( err != null && err.response != null && err.response.status === 401 && blib.Cookie.get( "isLogedIn" ) !== "true" ) {
			reduxStore.dispatch( login.reduxScafolding.action.Logout() );
		}
		return Promise.reject( err );
	} );
	const history = blib.History.createHashHistory(); //use hash based history
	blib.ReduxSimpleRouter.syncReduxAndRouter( history, reduxStore );



	blib.ReactDOM.render( (

		<blib.ReactRedux.Provider store={ reduxStore }>
			<div>
				<blib.ReactRouter.Router history={ history }>
					<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root } component={ components.RootTemplate }>
						<blib.ReactRouter.IndexRoute component={ components.Splash } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.accountDetails } component={ accountDetails.components.AccountDetails } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signup } component={ signup.components.StartSignup } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signupEmailCheckEmail } component={ signup.components.SignupEmailCheckEmail } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signupEmailSetPassword } component={ signup.components.SignupEmailSetPassword } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.login } component={ login.components.Login } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.resetPasswordStart } component={ resetPassword.components.StartReset } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.resetPasswordFinish } component={ resetPassword.components.EndReset } />
						<blib.ReactRouter.Route path={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.statements } component={ statements.components.Page } />
					</blib.ReactRouter.Route>
				</blib.ReactRouter.Router>
				{ __.isTrace ? <reduxDevTools.DevTools /> : "" }
			</div>
		</blib.ReactRedux.Provider>
	), document.getElementById( "react-mount" ) );
}